export const getProductDisplayPrice = (product) => {
  if (!product) return 0;
  if (product.lowestPrice?.price != null) return product.lowestPrice.price;
  if (product.display_price != null) return product.display_price;
  return product.price ?? 0;
};

export const formatProductPriceLabel = (product) => {
  const price = getProductDisplayPrice(product);
  const numeric = Number(price);
  if (Number.isNaN(numeric)) return "RM0";
  return `RM${numeric}`;
};
